import { createSelector } from 'reselect'
import { selectCurrentCustomerId } from 'selectors/tickets'

import { emptyArr } from 'util/arrays'

function selectBase(state) {
  return state.inAppCards.recentConversations
}

export function selectRecentTickets(state, customerId) {
  const byCustomerId = selectBase(state)[customerId]
  return (byCustomerId && byCustomerId.tickets) || emptyArr
}

export const selectBaseForCurrentCustomer = createSelector(
  selectBase,
  selectCurrentCustomerId,
  (base, customerId) => base[customerId]
)

export function selectRecentTicketsLoaded(state, customerId) {
  const byCustomerId = selectBase(state)[customerId]
  return !!(byCustomerId && byCustomerId.tickets)
}

export function selectIsLoading(state, customerId) {
  const byCustomerId = selectBase(state)[customerId]
  return byCustomerId && byCustomerId.loading
}

export const selectIsOrWillBeLoadingForCurrentCustomer = createSelector(
  selectBaseForCurrentCustomer,
  base => !base || base.loading
)

export function selectIsShowingAll(state, customerId) {
  const byCustomerId = selectBase(state)[customerId]
  return byCustomerId && byCustomerId.showingAll
}

export function selectHasLoadedAll(state, customerId) {
  const byCustomerId = selectBase(state)[customerId]
  return byCustomerId && byCustomerId.loadedAll
}

export function selectShouldReload(state, customerId) {
  const byCustomerId = selectBase(state)[customerId]
  return byCustomerId && byCustomerId.reload
}
